import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import decode from 'jwt-decode';
import { Observable } from 'rxjs';
import { UserService } from '../services/user/user.service';

@Injectable({
  providedIn: 'root'
})
export class RoleguardServiceGuard implements CanActivate {

  isAuth: Boolean;
  isAdmin: Boolean;
  isUserHr: Boolean;
  isUserVendor: boolean;

  constructor(public userService: UserService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    // this will be passed from the route config
    // on the data property
    const expectedRole = route.data.expectedRole;

    //const token = localStorage.getItem('userToken');
    // decode the token to get its payload
    //const tokenPayload = decode(token);
    this.userService.isUserAdmin.subscribe(
      value => {
        this.isAdmin = value;
      });

    this.userService.isUserHr.subscribe(
      value => {
        this.isUserHr = value;
      });

    this.userService.isUserVendor.subscribe(
      value => {
        this.isUserVendor = value;
      });

    this.userService.isAuthenticated.subscribe(
      value => {
        this.isAuth = value;
      });

    // if (!this.isAdmin || !this.isAuth) {
    //   this.router.navigate(['/dashboard']);
    //   return false;
    // }

    if (this.isUserVendor || !this.isAuth) {
      this.router.navigate(['/dashboard']);
      return false;
    }
    
    return true;
  }
}
